<template>
    <div class="filterbar-analytics-time-practice-mode">
        <button
            v-for="filtertag in filtertags" :key="filtertag.id"
            class="filterbar-analytics-time-practice-mode__filtertag"
            :class="selectionClass(filtertag)"
            @click="selectFiltertag(filtertag)">
            <span class="filterbar-analytics-time-practice-mode__filtertag-text">{{ filtertag.text }}</span>
        </button>
    </div>
</template>
<script>
    export default {
        computed: {
            filtertags(){
                return this.$store.state.filtertags.analyticsPractice.timePracticeMode;
            }
        },

        methods: {
            selectionClass(filtertag){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsPractice.timePracticeMode.type;
                return selectedFiltertagType === filtertag.type
                       ? 'filterbar-analytics-time-practice-mode--selected-filtertag'
                       : '';
            },

            selectFiltertag(filtertag){
                this.$store.commit('setSelectedFiltertag', {
                    categoryLabel: 'analyticsPractice',
                    filtertagLabel: 'timePracticeMode',
                    filtertag: filtertag
                });
                this.$store.state.sfx.filterbarClick.currentTime = 0;
                this.$store.state.sfx.filterbarClick.play();
            }
        }
    };
</script>
<style scoped src="@/css/components/filterbar-analytics-time-practice-mode.css"></style>